(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kutublink-aalimbooks-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initVoiceSearch = (root) => {
      if (!root) return;
      root.querySelectorAll('[data-kutub-search]').forEach((form) => {
        if (form.dataset.kutubVoiceReady === 'true') return;
        form.dataset.kutubVoiceReady = 'true';

        const voiceButton = form.querySelector('[data-kutub-voice]');
        const status = form.querySelector('[data-kutub-status]');
        if (!voiceButton || !status) return;

        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
          voiceButton.hidden = true;
          status.textContent = 'Voice search is not supported by this browser. Text search remains available.';
          return;
        }

        voiceButton.addEventListener('click', () => {
          const recognition = new SpeechRecognition();
          const languageField = form.querySelector('[data-kutub-voice-language]');
          const speechLanguages = { English: 'en-GB', Arabic: 'ar-SA', Urdu: 'ur-PK' };
          recognition.lang = speechLanguages[languageField?.value] || document.documentElement.lang || 'en-GB';
          recognition.interimResults = false;
          recognition.maxAlternatives = 1;
          recognition.addEventListener('result', (event) => {
            const input = form.querySelector('input[name="q"]');
            if (!input || !event.results[0] || !event.results[0][0]) return;
            input.value = event.results[0][0].transcript;
            status.textContent = 'Voice query added. Review it, then search.';
            input.focus();
          });
          recognition.addEventListener('error', () => {
            status.textContent = 'Voice search could not start. Please use text search.';
          });
          try {
            status.textContent = 'Listening…';
            recognition.start();
          } catch (error) {
            status.textContent = 'Voice search could not start. Please use text search.';
          }
        });
      });
    };

    document.querySelectorAll('[data-kutub-home]').forEach(initVoiceSearch);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-kutub-home]')
        ? event.target
        : event.target.querySelector('[data-kutub-home]');
      initVoiceSearch(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
